import { formatFileSize } from "../lib/format-file-size";

export const FILE_SIZE_LIMIT_BYTES = {
  DEFAULT: 5 * 1024 * 1024,
  CONTENT_AND_VIDEO: 100 * 1024 * 1024,
} as const;

export const FILE_SIZE_LIMIT_LABEL = {
  DEFAULT: "5 МБ",
  CONTENT_AND_VIDEO: "100 МБ",
} as const;

export const getFileSizeLimitError = (
  file: File,
  maxBytes: number,
): string | null => {
  if (file.size <= maxBytes) {
    return null;
  }

  return `Файл слишком большой (${formatFileSize(file.size)}). Максимум: ${formatFileSize(maxBytes)}`;
};
